<footer class="footer background-snow">
    <span class="text-muted">Copyright © 1996-{{currentYear}} WatchGuard Technologies, Inc. All Rights Reserved.</span>
</footer>
